module.exports = __webpack_public_path__ + "img/ex3.312a7049.png";